module.exports = __webpack_public_path__ + "img/portfolio-04-481x325.f080392e.jpg";